<template>
  <RouterView />
  <UIToast />
</template>

<script setup lang="ts">
import UIToast from './views/components/ui/toasts/UIToast.vue'
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  background-repeat: no-repeat;
  box-sizing: inherit;

  &:before,
  &:after {
    background-repeat: no-repeat;
    box-sizing: inherit;
  }
}

html {
  --Colors-Text-text-tertiary_on-brand: #a8d7cb;
  --Colors-Background-bg-brand-section: #024838;
  --ColorsEffectsShadowsshadow-xl03: 0 3px 3px -1.5px rgba(0, 16, 53, 0.04);
  --ColorsEffectsShadowsshadow-xl03: 0 3px 3px -1.5px rgba(121, 127, 141, 0.04);
  --ColorsEffectsShadowsshadow-xl02: 0 8px 8px -4px rgba(0, 16, 53, 0.03);
  --ColorsEffectsShadowsshadow-xl01: 0 20px 24px -4px rgba(0, 16, 53, 0.08);

  --Colors-Effects-Shadows-shadow-sm_01: rgba(0, 16, 53, 0.1);
  --ColorsEffectsShadowsshadow-sm01: rgba(0, 16, 53, 0.1);
  --Colors-Effects-Shadows-shadow-sm_02: rgba(0, 16, 53, 0.1);
  --ColorsEffectsShadowsshadow-sm02: rgba(0, 16, 53, 0.1);

  --Font-size-text-xs: 0.75rem;
  --Font-size-text-sm: 0.875rem;
  --Font-size-text-md: 1rem;
  --Font-size-text-lg: 1.125rem;
  --Font-size-text-xl: 1.25rem;
  --Font-size-display-xs: 1.5rem;
  --Font-size-display-sm: 1.875rem;
  --Font-size-display-md: 2.25rem;
  --Font-size-display-lg: 3rem;
  --Font-size-display-xl: 3.75rem;
  --Font-size-display-2xl: 4.5rem;

  --Line-height-text-xs: 1.125rem;
  --Line-height-text-sm: 1.25rem;
  --Line-height-text-md: 1.5rem;
  --Line-height-text-lg: 1.75rem;
  --Line-height-text-xl: 1.875rem;
  --Line-height-display-xs: 2rem;
  --Line-height-display-sm: 2.375rem;
  --Line-height-display-md: 2.75rem;
  --Line-height-display-lg: 3.75rem;
  --Line-height-display-xl: 4.5rem;
  --Line-height-display-2xl: 5.625rem;

  line-height: 1.5;
  font-family: $font-inter, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  word-break: normal;
  -moz-tab-size: 4;
  tab-size: 4;
  box-sizing: border-box;
  overflow-x: hidden;
  font-size: 16px;
}

button {
  background-color: transparent;
  border-style: none;
  cursor: pointer;
}

button,
input,
optgroup,
select,
textarea {
  font: inherit;
  appearance: none;
}

a {
  color: $color-ui-gray-cool-600;
}

body {
  margin: 0;
  --ck-z-default: 2000;
  --ck-z-panel: calc(var(--ck-z-default) + 999);
}

#AppContainer {
  min-height: 100vh;
  font-family: $font-inter;
  color: $newcolor-secondary-main;
  background-color: $color-white;
}
</style>
